module.exports = __webpack_public_path__ + "img/digita-logo-dark.8e11dfca.png";